import React from 'react';
import { Col } from 'antd';
import moment from 'moment';
import { I18n } from '@aws-amplify/core';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { Topic, Value } from '../styles';

export const CollectionDate = () => {
	const {
		libertyMutualResult: {
			informations: { collection_date }
		}
	} = useLibertyMutualSubStepsContext();

	return (
		<Col xs={24}>
			<Topic>{I18n.get('Collection date')}:</Topic>
			<Value>{moment(collection_date).format('L')}</Value>
		</Col>
	);
};
